import React from 'react';

import TestimonialSection from './TestimonialSection';
import ServiceSlider from "./ServiceSlider2";
import FaqAccordion from "./FaqAccordion";
import ContactSection from "./ContactSection";
import Footer from "./Footer"; 
import CScontent1 from "./CScontent1";
import CScontent12 from "./CScontent1_2";
import Number from "./numbers";

const CaseStudiesOne = () => {
  return (
    <>
      <CScontent1 />

      <TestimonialSection />
      <Number></Number>
        <div style={{ marginTop: "250px" }}>
       <ServiceSlider />
       </div>
        <CScontent12/>
       <FaqAccordion />
      <ContactSection />
      <Footer />
    </>
  );
};

export default CaseStudiesOne;